import { render, staticRenderFns } from "./WatchTutorial.vue?vue&type=template&id=6287bac5&scoped=true&"
import script from "./WatchTutorial.vue?vue&type=script&lang=js&"
export * from "./WatchTutorial.vue?vue&type=script&lang=js&"
import style0 from "./WatchTutorial.vue?vue&type=style&index=0&id=6287bac5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6287bac5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VContainer,VRow})
